export async function submitOTP(otp, mobile) {
    const url = `/common/verifymobile2/?code=${otp}&mobile=${mobile}`;
    try {
      const resp = await fetch(url);
      const response = await resp.json();
      return response.status;
    } catch (err) {
      console.trace(err);
      return false;
    }
  }
  
  export async function resendOTP(mobile) {
    const url = `/common/verifymobile2/?mobile=${mobile}`;
    try {
      const resp = await fetch(url);
      const response = await resp.json();
      return response.status;
    } catch (err) {
      console.trace(err);
      return false;
    }
  }
  